import { ColorsEnum } from "../et3-theme/colors";

const ALPHA_SHADOW = "29";
const ALPHA_SHADOW_STRONG = "3D";

export const BUTTON_RADIUS = 12;
export const BUTTON_LARGE_FONT_SIZE = 16;
export const BUTTON_DEFAULT_FONT_SIZE = 15;
export const BUTTON_COMPACT_FONT_SIZE = 13;
export const BUTTON_COMPACT_PADDING_X = 14;
export const BUTTON_COMPACT_HEIGHT = 30;
export const BUTTON_COMPACT_RADIUS = 9;
export const BUTTON_PRESS_OFFSET = 1;
export const BUTTON_HOVER_BRIGHTNESS = "brightness(94%)";
export const BUTTON_RESTING_BRIGHTNESS = "none";

export const BUTTON_DISABLED_BACKGROUND = ColorsEnum.shadeOfGray;

export const BUTTON_SHADOW = `0 2px 6px ${ColorsEnum.maastrichtBlue}${ALPHA_SHADOW}`;
export const BUTTON_SHADOW_HOVER = `0 6px 16px ${ColorsEnum.maastrichtBlue}${ALPHA_SHADOW_STRONG}`;
export const BUTTON_SHADOW_DISABLED = "none";
export const BUTTON_TRANSITION =
  "box-shadow 160ms cubic-bezier(0.4, 0, 0.2, 1), transform 160ms cubic-bezier(0.4, 0, 0.2, 1), filter 160ms cubic-bezier(0.4, 0, 0.2, 1)";
